"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSignal2 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconSignal2 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.63604 2.22173C6.02656 2.61225 6.02656 3.24542 5.63604 3.63594C2.12132 7.15066 2.12132 12.8491 5.63604 16.3639C6.02656 16.7544 6.02656 17.3876 5.63604 17.7781C5.24551 18.1686 4.61235 18.1686 4.22183 17.7781C-0.0739419 13.4823 -0.0739419 6.51749 4.22183 2.22173C4.61235 1.8312 5.24551 1.8312 5.63604 2.22173Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.46469 6.4644C8.85521 6.07388 8.85521 5.44071 8.46469 5.05019C8.07416 4.65966 7.441 4.65966 7.05047 5.05019C4.3168 7.78386 4.3168 12.216 7.05047 14.9497C7.441 15.3402 8.07416 15.3402 8.46469 14.9497C8.85521 14.5592 8.85521 13.926 8.46469 13.5355C6.51207 11.5828 6.51207 8.41702 8.46469 6.4644Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.95 5.05019C16.5595 4.65966 15.9263 4.65966 15.5358 5.05019C15.1453 5.44071 15.1453 6.07388 15.5358 6.4644C17.4884 8.41702 17.4884 11.5828 15.5358 13.5355C15.1453 13.926 15.1453 14.5592 15.5358 14.9497C15.9263 15.3402 16.5595 15.3402 16.95 14.9497C19.6837 12.216 19.6837 7.78386 16.95 5.05019Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.7786 2.22173C19.3881 1.8312 18.7549 1.8312 18.3644 2.22173C17.9739 2.61225 17.9739 3.24542 18.3644 3.63594C21.8791 7.15066 21.8791 12.8491 18.3644 16.3639C17.9739 16.7544 17.9739 17.3876 18.3644 17.7781C18.7549 18.1686 19.3881 18.1686 19.7786 17.7781C24.0744 13.4823 24.0744 6.51749 19.7786 2.22173Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0002 12.8293C14.1654 12.4174 15.0002 11.3062 15.0002 9.99997C15.0002 8.34312 13.6571 6.99997 12.0002 6.99997C10.3434 6.99997 9.00022 8.34312 9.00022 9.99997C9.00022 11.3062 9.83503 12.4174 11.0002 12.8293V21C11.0002 21.5523 11.4479 22 12.0002 22C12.5525 22 13.0002 21.5523 13.0002 21V12.8293Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.2429 5.75732C18.586 8.10047 18.586 11.8995 16.2429 14.2426M7.75758 14.2426C5.41443 11.8995 5.41443 8.10047 7.75758 5.75732M4.92893 17.0711C1.02369 13.1658 1.02369 6.8342 4.92893 2.92896M19.0715 2.92896C22.9768 6.8342 22.9768 13.1658 19.0715 17.0711M12.0002 12C13.1048 12 14.0002 11.1046 14.0002 10C14.0002 8.89543 13.1048 8 12.0002 8C10.8957 8 10.0002 8.89543 10.0002 10C10.0002 11.1046 10.8957 12 12.0002 12ZM12.0002 12V21",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconSignal2 = IconSignal2;
//# sourceMappingURL=IconSignal2.js.map